import AdminRoleGuard from './adminRoleGuard';

export default AdminRoleGuard;
